import {CSSProperties, MouseEvent, useMemo, memo} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {useIntl} from 'react-intl';

import {setStatusDropdown} from 'actions/views/status_dropdown';
import CustomStatusEmoji from 'components/custom_status/custom_status_emoji';
import {
    makeGetCustomStatus,
    showPostHeaderUpdateStatusButton,
    isCustomStatusEnabled,
} from 'selectors/views/custom_status';
import {GlobalState} from 'types/store';
import EmojiIcon from 'components/widgets/icons/emoji_icon';

interface ComponentProps {
    userId: string;
    isSystemMessage: boolean;
    isBot: boolean;
}

const EMOJI_STYLE: CSSProperties = {
    position: 'relative',
    top: 1,
    marginLeft: 4,
};

const PostHeaderCustomStatus = memo((props: ComponentProps) => {
    const {userId, isSystemMessage, isBot} = props;
    const {formatMessage} = useIntl();
    const dispatch = useDispatch();
    const getCustomStatus = useMemo(makeGetCustomStatus, []);
    const userCustomStatusEmoji = useSelector((state: GlobalState) => getCustomStatus(state, userId)?.emoji);
    const showUpdateStatusButton = useSelector(showPostHeaderUpdateStatusButton);
    const customStatusEnabled = useSelector(isCustomStatusEnabled);

    const updateStatus = (event: MouseEvent) => {
        event.preventDefault();
        dispatch(setStatusDropdown(true));
    };

    if (!customStatusEnabled || isSystemMessage || isBot) {
        return null;
    }

    if (userCustomStatusEmoji) {
        return (
            <CustomStatusEmoji
                userID={userId}
                showTooltip={true}
                emojiStyle={EMOJI_STYLE}
            />
        );
    }

    // This must be checked after checking that custom status is not null
    if (!showUpdateStatusButton) {
        return null;
    }

    return (
        <button
            onClick={updateStatus}
            className='post__header-set-custom-status cursor--pointer style--none'
        >
            <EmojiIcon className='post__header-set-custom-status-icon' />
            <span className='post__header-set-custom-status-text'>
                {formatMessage({
                    id: 'post_header.update_status',
                    defaultMessage: 'Update your status',
                })}
            </span>
        </button>
    );
});

export default PostHeaderCustomStatus;
